import ImpactAnalysis from './ImpactAnalysis.container';

export default ImpactAnalysis;
